import { NavigationService } from "@10x/coreapp/NavigationService";
import MainScreen from "./screens";

export function registerRoutes( navigationService: NavigationService ) {
	navigationService.registerRoute( {
		myDLD: {
			component: MainScreen,
			path: "/rentalvaluation",
		}
	} );
}
